import React from 'react';
import { Container, StyledAbout, Text, Skills } from './styles/About.styled';

import { expertise } from '../data';
import { Heading } from './styles/SharedStyles';

const About = () => {
  return (
    <StyledAbout id="about">
      <Container>
        <Heading>About me</Heading>
        <Text>
          <p>
          Hello! My name is <span>Lian Paul Molo</span> and I am a driven <span>front-end developer</span> with a passion for creating visually appealing and user-friendly websites and web applications. I recently graduated from Access Computer College with a Bachelor of Science in Information Technology and am eager to apply my education and skills in a challenging and dynamic work environment.
          </p>
          {/* <p>
            I have a passion for coding and challenging myself creatively. I'm
            continuously learning and improving my skills each day, where my
            focus is on JavaScript, React, and Next.js
          </p> */}
        </Text>

        <Skills>
          <h4>Here are the technologies I’ve been working with.</h4>
          <section>
            {expertise.map((item, i) => {
              return (
                <li key={i}>
                  <div>{item.icon}</div>
                  <p>{item.text}</p>
                </li>
              );
            })}
          </section>
        </Skills>

        {/* <Skills>
          <h4>Top Expertise</h4>
          <section>
            <div>
              <p>Programming Languages</p>
              <ul>
                {skills.language.map((item, i) => {
                  return (
                    <li key={i}>
                      {skills.icon}
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div>
              <p>Libraries & Frameworks</p>
              <ul>
                {skills.libraries.map((item, i) => {
                  return (
                    <li key={i}>
                      {skills.icon}
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div>
              <p>Tools</p>
              <ul>
                {skills.tools.map((item, i) => {
                  return (
                    <li key={i}>
                      {skills.icon}
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </section>

          <section>
            <div>
              <p className="experience-with">
                Here are a few technologies I’ve been experience working with
              </p>
              <ul>
                {skills.experience.map((item, i) => {
                  return (
                    <li key={i}>
                      {skills.icon}
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </section>
        </Skills> */}
      </Container>
    </StyledAbout>
  );
};

export default About;
